import { render, staticRenderFns } from "./ActivityFeedRow.vue?vue&type=template&id=327d607d&scoped=true"
import script from "./ActivityFeedRow.vue?vue&type=script&lang=js"
export * from "./ActivityFeedRow.vue?vue&type=script&lang=js"
import style0 from "./ActivityFeedRow.vue?vue&type=style&index=0&id=327d607d&prod&lang=scss&scoped=true"
import style1 from "./ActivityFeedRow.vue?vue&type=style&index=1&id=327d607d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327d607d",
  null
  
)

export default component.exports